import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from 'components/PageHeader';
import LanguageToggle from 'components/LanguageToggle';
import {
  activationTestFlowPath,
  ActivationTestFlow
} from 'core/constants/activationTest';
import useLocales from 'hooks/useLocales';

import './Index.scss';

const FLOWS: {
  id: ActivationTestFlow;
  title: string;
  description: string;
}[] = [
  {
    id: 'candidate',
    title: 'Candidate',
    description:
      'Welcome → who you are → match preferences → education. Final step shows the API JSON (nothing is sent).'
  },
  {
    id: 'company',
    title: 'Company',
    description:
      'Welcome → logo → avatar → company info → culture profile. Final step shows the API JSON (nothing is sent).'
  },
  {
    id: 'recruiter',
    title: 'Recruiter',
    description:
      'Welcome → avatar → recruiter settings. Final step shows the API JSON (nothing is sent).'
  }
];

const TestActivationHub = (): JSX.Element => {
  const { t } = useLocales();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader showLogo={false} showLanguageSelector={false} />
      <div className="test-activation">
        <div className="test-activation__card">
          <span className="test-activation__title">
            {t('Test activation')}
          </span>
          <p className="test-activation__desc">
            {t(
              'Walk through onboarding without creating a user. At the last step you get the API payload JSON to inspect or download. Nothing is saved and is_new is not changed.'
            )}
          </p>
          <div className="test-activation__grid">
            {FLOWS.map((flow) => (
              <button
                key={flow.id}
                type="button"
                className={`test-activation__flow${
                  flow.id === 'recruiter' ? ' test-activation__flow--wide' : ''
                }`}
                onClick={() => navigate(activationTestFlowPath(flow.id))}
              >
                <span className="test-activation__flow-title">
                  {t(flow.title)}
                </span>
                <p className="test-activation__flow-copy">
                  {t(flow.description)}
                </p>
              </button>
            ))}
          </div>
          <LanguageToggle />
        </div>
      </div>
    </>
  );
};

export default TestActivationHub;
